var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgWarningIcon = function SvgWarningIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.2996 12.8669L6.06625 60.0002C5.48414 61.0083 5.17614 62.1512 5.17288 63.3153C5.16962 64.4793 5.47122 65.624 6.04767 66.6353C6.62412 67.6466 7.45533 68.4894 8.45861 69.0797C9.46188 69.67 10.6022 69.9874 11.7662 70.0002H68.2329C69.3969 69.9874 70.5373 69.67 71.5406 69.0797C72.5438 68.4894 73.375 67.6466 73.9515 66.6353C74.5279 65.624 74.8295 64.4793 74.8263 63.3153C74.823 62.1512 74.515 61.0083 73.9329 60.0002L45.6996 12.8669C45.1053 11.8872 44.2687 11.0773 43.2702 10.5151C42.2718 9.95302 41.1454 9.65771 39.9996 9.65771C38.8538 9.65771 37.7274 9.95302 36.7289 10.5151C35.7305 11.0773 34.8938 11.8872 34.2996 12.8669V12.8669Z",
    stroke: "#FFC116",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 30V43.3333",
    stroke: "#FFC116",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40 56.6665H40.0333",
    stroke: "#FFC116",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgWarningIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "warning-icon.07cd7d0f8c8970de6364d1785413a0fa.svg";